import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=67a25b99&scoped=true"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"
import style0 from "./Thankyou.vue?vue&type=style&index=0&id=67a25b99&prod&scoped=true&lang=css"
import style1 from "./Thankyou.vue?vue&type=style&index=1&id=67a25b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a25b99",
  null
  
)

export default component.exports